// https://academind.com/tutorials/reactjs-a-custom-useform-hook/

import { useReducer } from "react";

const nameValidator = (value) => {
    // const validRegex = /^[a-zA-Z]+$/;

    if (value.length === 0) {
        return "Name cannot be empty"
    } else {
        return ""
    }
}

const passwordValidator = (value) => {
    const validRegex = /^[\w| !"§$%&/()=\-?*]*$/;

    if (value.length < 2) {
        return "Password cannot be empty"
    } else if (!value.match(validRegex)) {
        return "Password not correct"
    } else {
        return ""
    }
}

export const TypeInput = {
    NAME: "name",
    PASSWORD: "password"
}

const initialInputState = {
    value: "",
    isTouched: false,
    errorMessage: ""
}

const inputValidator = (value, typeInput) => {
    if (typeInput === TypeInput.NAME) {
        return nameValidator(value)
    }
    if (typeInput === TypeInput.PASSWORD) {
        return passwordValidator(value)
    }
}


const inputStateReducer = (state, action) => { // state -> previous state 
    if (action.type === "INPUT") {
        return {
            value: action.value,
            isTouched: true,
            errorMessage: inputValidator(action.value, action.typeInput)
        }
    }
    if (action.type === "BLUR") {
        return {
            isTouched: true,
            value: state.value,
            errorMessage: inputValidator(action.value, action.typeInput)
        }
    }
    if (action.type === "RESET") {
        return {
            isTouched: false,
            value: "",
            errorMessage: ""
        };
    }
    return initialInputState
}


const useInput = () => {
    const [inputState, dispatch] = useReducer(inputStateReducer, initialInputState)

    const hasError = inputState.isTouched && (inputState.errorMessage.length > 0);
    const isValid = inputState.errorMessage.length === 0 && inputState.value.length > 0;

    const valueChangeHandler = (event) => {
        dispatch({ type: 'INPUT', value: event.target.value, typeInput: event.target.name })
    };

    const inputBlurHandler = (event) => {
        dispatch({ type: 'BLUR', value: event.target.value, typeInput: event.target.name })
    };

    const reset = () => {
        dispatch({ type: "RESET" })
    }

    return {
        value: inputState.value,
        isValid: isValid,
        errorMessage: inputState.errorMessage,
        hasError: hasError,
        valueChangeHandler,
        inputBlurHandler,
        reset
    };
};

export default useInput;
